(function () {
    'use strict';

    run.admin.parts.tileSuggest = function() {
        const csrf_name = document.getElementsByName('csrf_name')[0].value;
        const csrf_value = document.getElementsByName('csrf_value')[0].value;

        const rackoot_data = document.getElementById('rackoot_data');

        const btn_suggest = document.getElementById('btn_suggest_tile');
        btn_suggest.addEventListener('click', suggestTile);

        async function suggestTile() {
            let suggest_tile_template = document.getElementById('suggest_tile_template').innerHTML;
            const { value: suggestTileValues } = await Swal.fire({
                title: translations.tiles.suggest.messages.title,
                html: suggest_tile_template,
                showCloseButton: false,
                showCancelButton: true,
                showConfirmButton: true,
                focusCancel: true,
                cancelButtonText: translations.tiles.suggest.messages.buttonCancel,
                confirmButtonText: translations.tiles.suggest.messages.buttonConfirm,
                buttonsStyling: false,
                reverseButtons: true,
                customClass: {
                    cancelButton: 'btn btn-lg btn-light',
                    confirmButton: 'btn btn-lg btn-primary ms-4'
                },
                showClass: {
                    popup: 'animate__animated animated__fast animate__fadeInUp'
                },
                hideClass: {
                    popup: 'animate__animated animated__fast animate__fadeOutDown'
                },
                didOpen: () => {
                    const url_input = document.getElementById('form_suggest_tile__url');
                    const url_parse_button = document.getElementById('form_suggest_tile__extract_data');
                    url_input.addEventListener('input', function(e) {
                        if (url_input.value.length > 5) {
                            url_parse_button.disabled = false;
                        } else {
                            url_parse_button.disabled = true;
                        }
                    });
                },
                preConfirm: () => {
                    const url_input = document.getElementById('form_suggest_tile__url');
                    const url = prependHttp(url_input.value);
                    if (!isValidUrl(url)) {
                        Swal.showValidationMessage('URL is not valid');
                        return false;
                    }

                    if (
                        !document.getElementById('form_suggest_tile__name').value ||
                        !document.getElementById('form_suggest_tile__url').value
                    ) {
                        Swal.showValidationMessage('Please complete all the required fields')
                    } else {
                        return [
                            document.getElementById('form_suggest_tile__name').value,
                            document.getElementById('form_suggest_tile__url').value,
                            document.getElementById('form_suggest_tile__description').value,
                        ]
                    }
                }
            })
              
            if (suggestTileValues) {
                const btn_suggest_title = btn_suggest.querySelector('.tool__name span');

                btn_suggest.setAttribute('disabled', 'disabled');
                btn_suggest_title.innerHTML = btn_suggest.dataset.labelLoading;

                var data = new FormData();
                data.append('csrf_name', csrf_name);
                data.append('csrf_value', csrf_value);
                data.append('rackoot_uuid', rackoot_data.dataset.uuid);
                data.append('name', suggestTileValues[0]);
                data.append('url', suggestTileValues[1]);
                data.append('description', suggestTileValues[2]);

                axios.post(GlobalRoutes.tiles.suggest, data)
                .then(function (response) {
                    Swal.fire(
                        translations.tiles.suggest.success.title,
                        translations.tiles.suggest.success.body
                    );
                    // new Toast(translations.tiles.suggest.messages.success, Toast.TYPE_DONE, Toast.TIME_NORMAL);
                })
                .catch(function (error) {
                    Swal.fire({
                        icon: 'error',
                        title: translations.tiles.suggest.error.title,
                        html: error.response.data.details
                    });
                    // new Toast(, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                })
                .then(() => {
                    btn_suggest.removeAttribute('disabled');
                    btn_suggest_title.innerHTML = btn_suggest.dataset.label;
                });    
            }
        }

        document.body.addEventListener('click', function(e) {
            const url_input = document.getElementById('form_suggest_tile__url');
            const url_parse_button = document.getElementById('form_suggest_tile__extract_data');
            if (e.target && e.target.id== 'form_suggest_tile__extract_data') {
                const title_input = document.getElementById('form_suggest_tile__name');
                const desc_input = document.getElementById('form_suggest_tile__description');

                const values = {
                    csrf_name: csrf_name,
                    csrf_value: csrf_value,
                    url: url_input.value,
                }

                url_parse_button.disabled = true;
                title_input.disabled = true;
                desc_input.disabled = true;
                url_parse_button.innerText = url_parse_button.dataset.textLoading;

                axios.post(GlobalRoutes.tools.parse_url, values)
                .then(function (response) {
                    if (response.data.status == "success") {
                        if (response.data.data.title !== null && response.data.data.title !== 'undefined') {
                            title_input.value = response.data.data.title;
                        }
                        if (response.data.data.description !== null && response.data.data.description !== 'undefined') {
                            desc_input.value = response.data.data.description;
                        }
                    }
                    url_parse_button.disabled = false;
                    url_parse_button.innerText = url_parse_button.dataset.text;
                    title_input.disabled = false;
                    desc_input.disabled = false;
                    })
                .catch(function (error) {
                    new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                    url_parse_button.disabled = false;
                    url_parse_button.innerText = url_parse_button.dataset.text;
                    title_input.disabled = false;
                    desc_input.disabled = false;
                });
    
            }
        });
    };
})();
